export interface InputMaskConfiguration {
    mask?: string;
    provider?: InputMaskProvider;
    settings?: object | InputMaskDefinedSettings;
}

export enum InputMaskProvider {
    IgoreScobar,
    RobinHerbots
}

export interface InputMaskDefinedSettings {
    prefix?: string;
    suffix?: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/inputmask/inputmask.interfaces.ts